import { configureStore } from '@reduxjs/toolkit';
import resourcesReducer from './getResourcesSlice';
import cropNutritionReducer from './getCropNutritionSlice';
import trialResultsReducer from './getTrialResultsSlice';
import careerReducer from './getCareerSlice';

export const store = configureStore({
    reducer: {
        resources: resourcesReducer,
        cropNutrition: cropNutritionReducer,
        trialResults: trialResultsReducer,
        career: careerReducer,
    },
});

export default store;
